import { getBoundedValue } from "utils/math/math.utils";

export const getVisibleRange = ({itemCount, selectedIndex, visibleNumOfItems}) => {
  if(itemCount <= visibleNumOfItems) {
    return { startIndex: 0, endIndex: itemCount };
  }

  const safeSelectedIndex = getBoundedValue(selectedIndex, 0, itemCount - 1); // Ensures the selected index is within first and last item
  const maxStartIndex = itemCount - visibleNumOfItems; // The maximum starting index to ensure we have enough items to display
  const preferredStartIndex = safeSelectedIndex - Math.floor(visibleNumOfItems / 2); // Center the selected index
  const startIndex = getBoundedValue(preferredStartIndex, 0, maxStartIndex); // Ensure the start index isn't negative or too high

  return {startIndex, endIndex: startIndex + visibleNumOfItems}; // Return the calculated range of visible items
}